import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function Prebiotics(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual Finalidade?</span>
          </th>
          <th>
            <span>Qual Dose?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.pre.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.pre.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.pre.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.initial.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.initial.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.initial.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.growth.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.growth.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.growth.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Desenvolvimento</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.development.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.development.reason"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.development.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
